import axios from "../api";
import {objectToParam} from "../../libs/utils";
import {
    FrequentPassageStickerType,
    QueryListResult
} from '@legacy-types';
import { Nullable } from '@shared/utils/types';

export async function getFrequentPassageStickerTypes(params = {}): Promise<QueryListResult<FrequentPassageStickerType>> {
    const parameters = objectToParam(params);

    const {data} = await axios.get(
        `frequent-passage-sticker-types?${parameters}`
    );

    return data;
}

export async function getFrequentPassageStickerType(id: number): Promise<FrequentPassageStickerType> {
    const {data} = await axios.get(`frequent-passage-sticker-types/${id}`);

    return data;
}

export type CreateFrequentPassageStickerTypeRequest = Nullable<Pick<
    FrequentPassageStickerType,
    'name' | 'eventId' | 'requestDeadlineAt' | 'quantity' | 'voucherTemplateHtml'
>>;

export async function createFrequentPassageStickerType(values: CreateFrequentPassageStickerTypeRequest): Promise<FrequentPassageStickerType> {
    const {data} = await axios.post(
        `/frequent-passage-sticker-types`,
        values
    );

    return data;
}

export type UpdateFrequentPassageStickerTypeRequest = Nullable<Pick<
    FrequentPassageStickerType,
    'name' | 'eventId' | 'requestDeadlineAt' | 'quantity' | 'voucherTemplateHtml'
>>;

export async function updateFrequentPassageStickerType(id: number, values: UpdateFrequentPassageStickerTypeRequest): Promise<FrequentPassageStickerType> {
    const {data} = await axios.put(
        `/frequent-passage-sticker-types/${id}`,
        values
    );

    return data;
}

export async function deleteFrequentPassageStickerType(id: number): Promise<{}> {
    const {data} = await axios.delete(`/frequent-passage-sticker-types/${id}`);

    return data;
}
